import Constants from './Constants';
import Carbs from '../cards/food-cards/Carbs';
import Fats from '../cards/food-cards/Fats';
import Fruits from '../cards/food-cards/Fruits';
import Proteins from '../cards/food-cards/Proteins';
import Vegetables from '../cards/food-cards/Vegetables';
import Water from '../cards/food-cards/Water';
import Demo from '../cards/food-cards/Demo';
import OnionGarlicCard from '../cards/food-cards/OnionGarlicCard';
import CabbageBroccoliCard from '../cards/food-cards/CabbageBroccoliCard';
import JokerCard from '../cards/food-cards/JokerCard';
import VirusCard from '../cards/action-cards/VirusCard';
import StopCard from '../cards/action-cards/StopCard';
import SwitchFriendCard from '../cards/action-cards/SwitchFriendCard';
import SwitchStackCard from '../cards/action-cards/SwitchStackCard';
import SurpriseMealCard from '../cards/action-cards/SurpriseMealCard';
import BirthdayAttackCard from '../cards/action-cards/candy-attack-cards/BirthdayAttackCard';
import TripAttackCard from '../cards/action-cards/candy-attack-cards/TripAttackCard';
import GrandmaAttackCard from '../cards/action-cards/candy-attack-cards/GrandmaAttackCard';
import CandyCard from '../cards/CandyCard';

export default class CardTypes {
    static CARBS_CARD = 0;
    static FATS_CARD = 1;
    static FRUITS_CARD = 2;
    static PROTEINS_CARD = 3;
    static VEGETABLES_CARD = 4;
    static WATER_CARD = 5;
    static DEMO_CARD = 6;
    static ONION_GARLIC_CARD = 7;
    static CABBAGE_BROCCOLI_CARD = 8;
    static JOKER_CARD = 9;
    static VIRUS_CARD = 10;
    static STOP_CARD = 11;
    static SWITCH_FRIEND_CARD = 12;
    static SWITCH_STACK_CARD = 13;
    static SURPRISE_MEAL_CARD = 14;
    static BIRTHDAY_ATTACK_CARD = 15;
    static TRIP_ATTACK_CARD = 16;
    static GRANDMA_ATTACK_CARD = 17;
    static CANDY_CARD = 18;

    static DEAL_FIRST_TO_ENTITY_INDEX = Constants.COMPUTER_PLAYER_LEFT_INDEX;

    static NEW_PILE_DEAL_RULES = [
        { cardType: CardTypes.CARBS_CARD, percentage: 1000 },
        { cardType: CardTypes.FATS_CARD, percentage: 0 },
        { cardType: CardTypes.FRUITS_CARD, percentage: 0 },
        { cardType: CardTypes.PROTEINS_CARD, percentage: 0 },
        { cardType: CardTypes.VEGETABLES_CARD, percentage: 0 },
        { cardType: CardTypes.WATER_CARD, percentage: 0 },
        { cardType: CardTypes.DEMO_CARD, percentage: 0 },
        { cardType: CardTypes.ONION_GARLIC_CARD, percentage: 0 },
        { cardType: CardTypes.CABBAGE_BROCCOLI_CARD, percentage: 0},
        { cardType: CardTypes.JOKER_CARD, percentage: 0 }, // DON'T CHANGE TO 100!!! WILL CAUSE INFINITE LOOP
        { cardType: CardTypes.VIRUS_CARD, percentage: 0 },
        { cardType: CardTypes.STOP_CARD, percentage: 0 },
        { cardType: CardTypes.SWITCH_FRIEND_CARD, percentage: 0 },
        { cardType: CardTypes.SWITCH_STACK_CARD, percentage: 0 },
        { cardType: CardTypes.SURPRISE_MEAL_CARD, percentage: 0 },
        { cardType: CardTypes.BIRTHDAY_ATTACK_CARD, percentage: 0 },
        { cardType: CardTypes.TRIP_ATTACK_CARD, percentage: 0 },
        { cardType: CardTypes.GRANDMA_ATTACK_CARD, percentage: 0 }
    ];

    // In case NEW_PILE_DEAL_RULES percentage sum is not 100:
    static NEW_PILE_DEAL_RULES_ORIGIN = [
        { cardType: CardTypes.CARBS_CARD, percentage: 10.17 },
        { cardType: CardTypes.FATS_CARD, percentage: 10.17 },
        { cardType: CardTypes.FRUITS_CARD, percentage: 10.17 },
        { cardType: CardTypes.PROTEINS_CARD, percentage: 10.17 },
        { cardType: CardTypes.VEGETABLES_CARD, percentage: 6.79 },
        { cardType: CardTypes.WATER_CARD, percentage: 10.17 },
        { cardType: CardTypes.DEMO_CARD, percentage: 20.35 },
        { cardType: CardTypes.ONION_GARLIC_CARD, percentage: 3.4 },
        { cardType: CardTypes.CABBAGE_BROCCOLI_CARD, percentage: 3.4 },
        { cardType: CardTypes.JOKER_CARD, percentage: 1.69 },
        { cardType: CardTypes.VIRUS_CARD, percentage: 1.69 },
        { cardType: CardTypes.STOP_CARD, percentage: 1.69 },
        { cardType: CardTypes.SWITCH_FRIEND_CARD, percentage: 1.69 },
        { cardType: CardTypes.SWITCH_STACK_CARD, percentage: 1.69 },
        { cardType: CardTypes.SURPRISE_MEAL_CARD, percentage: 1.69 },
        { cardType: CardTypes.BIRTHDAY_ATTACK_CARD, percentage: 1.69 },
        { cardType: CardTypes.TRIP_ATTACK_CARD, percentage: 1.69 },
        { cardType: CardTypes.GRANDMA_ATTACK_CARD, percentage: 1.69 }
    ];

    static CANDY_PILE_DEAL_RULES = [
        { cardType: CardTypes.CANDY_CARD, percentage: 90.91 },
        { cardType: CardTypes.SURPRISE_MEAL_CARD, percentage: 3.03 },
        { cardType: CardTypes.JOKER_CARD, percentage: 3.03 },
        { cardType: CardTypes.SWITCH_FRIEND_CARD, percentage: 3.03 },
    ];

    static NEW_PILE_MAP = [

        // CARBS
        { front: "carbs1", back: "orange-back", type: CardTypes.CARBS_CARD, class: Carbs },
        { front: "carbs2", back: "orange-back", type: CardTypes.CARBS_CARD, class: Carbs },
        { front: "carbs3", back: "orange-back", type: CardTypes.CARBS_CARD, class: Carbs },
        { front: "carbs4", back: "orange-back", type: CardTypes.CARBS_CARD, class: Carbs },
        { front: "carbs5", back: "orange-back", type: CardTypes.CARBS_CARD, class: Carbs },
        { front: "carbs6", back: "orange-back", type: CardTypes.CARBS_CARD, class: Carbs },

        // FATS
        { front: "fats1", back: "yellow-back", type: CardTypes.FATS_CARD, class: Fats },
        { front: "fats2", back: "yellow-back", type: CardTypes.FATS_CARD, class: Fats },
        { front: "fats3", back: "yellow-back", type: CardTypes.FATS_CARD, class: Fats },
        { front: "fats4", back: "yellow-back", type: CardTypes.FATS_CARD, class: Fats },
        { front: "fats5", back: "yellow-back", type: CardTypes.FATS_CARD, class: Fats },
        { front: "fats6", back: "yellow-back", type: CardTypes.FATS_CARD, class: Fats },

        // FRUITS
        { front: "fruits1", back: "red-back", type: CardTypes.FRUITS_CARD, class: Fruits },
        { front: "fruits2", back: "red-back", type: CardTypes.FRUITS_CARD, class: Fruits },
        { front: "fruits3", back: "red-back", type: CardTypes.FRUITS_CARD, class: Fruits },
        { front: "fruits4", back: "red-back", type: CardTypes.FRUITS_CARD, class: Fruits },
        { front: "fruits5", back: "red-back", type: CardTypes.FRUITS_CARD, class: Fruits },
        { front: "fruits6", back: "red-back", type: CardTypes.FRUITS_CARD, class: Fruits },

        // PROTEINS
        { front: "proteins1", back: "white-back", type: CardTypes.PROTEINS_CARD, class: Proteins },
        { front: "proteins2", back: "white-back", type: CardTypes.PROTEINS_CARD, class: Proteins },
        { front: "proteins3", back: "white-back", type: CardTypes.PROTEINS_CARD, class: Proteins },
        { front: "proteins4", back: "white-back", type: CardTypes.PROTEINS_CARD, class: Proteins },
        { front: "proteins5", back: "white-back", type: CardTypes.PROTEINS_CARD, class: Proteins },
        { front: "proteins6", back: "white-back", type: CardTypes.PROTEINS_CARD, class: Proteins },

        // VEGETABLES
        { front: "vegetables1", back: "green-back", type: CardTypes.VEGETABLES_CARD, class: Vegetables },
        { front: "vegetables2", back: "green-back", type: CardTypes.VEGETABLES_CARD, class: Vegetables },
        { front: "vegetables3", back: "green-back", type: CardTypes.VEGETABLES_CARD, class: Vegetables },
        { front: "vegetables4", back: "green-back", type: CardTypes.VEGETABLES_CARD, class: Vegetables },

        // WATER
        { front: "water1", back: "blue-back", type: CardTypes.WATER_CARD, class: Water },
        { front: "water2", back: "blue-back", type: CardTypes.WATER_CARD, class: Water },
        { front: "water3", back: "blue-back", type: CardTypes.WATER_CARD, class: Water },

        // DEMO
        { front: "demo1", back: "white-back", type: CardTypes.DEMO_CARD, class: Demo },
        { front: "demo2", back: "yellow-back", type: CardTypes.DEMO_CARD, class: Demo },
        { front: "demo3", back: "orange-back", type: CardTypes.DEMO_CARD, class: Demo },
        { front: "demo4", back: "red-back", type: CardTypes.DEMO_CARD, class: Demo },
        { front: "demo5", back: "green-back", type: CardTypes.DEMO_CARD, class: Demo },
        { front: "demo6", back: "blue-back", type: CardTypes.DEMO_CARD, class: Demo },

        // ONOIN-GARLIC
        { front: "onion-garlic", back: "green-back", type: CardTypes.ONION_GARLIC_CARD, class: OnionGarlicCard },

        // CABBAGE-BROCCOLI
        { front: "cabbage-broccoli", back: "green-back", type: CardTypes.CABBAGE_BROCCOLI_CARD, class: CabbageBroccoliCard },

        //VIRUS
        { front: "virus1", back: "blue-back", type: CardTypes.VIRUS_CARD, class: VirusCard },
        { front: "virus2", back: "white-back", type: CardTypes.VIRUS_CARD, class: VirusCard },
        { front: "virus3", back: "green-back", type: CardTypes.VIRUS_CARD, class: VirusCard },

        // BIRTHDAY
        { front: "birthday1", back: "blue-back", type: CardTypes.BIRTHDAY_ATTACK_CARD, class: BirthdayAttackCard },
        { front: "birthday2", back: "green-back", type: CardTypes.BIRTHDAY_ATTACK_CARD, class: BirthdayAttackCard },
        { front: "birthday3", back: "yellow-back", type: CardTypes.BIRTHDAY_ATTACK_CARD, class: BirthdayAttackCard },

        // TRIP
        { front: "trip1", back: "blue-back", type: CardTypes.TRIP_ATTACK_CARD, class: TripAttackCard },
        { front: "trip2", back: "yellow-back", type: CardTypes.TRIP_ATTACK_CARD, class: TripAttackCard },
        { front: "trip3", back: "orange-back", type: CardTypes.TRIP_ATTACK_CARD, class: TripAttackCard },

        // GRANDMA
        { front: "grandma1", back: "white-back", type: CardTypes.GRANDMA_ATTACK_CARD, class: GrandmaAttackCard },
        { front: "grandma2", back: "red-back", type: CardTypes.GRANDMA_ATTACK_CARD, class: GrandmaAttackCard },
        { front: "grandma3", back: "green-back", type: CardTypes.GRANDMA_ATTACK_CARD, class: GrandmaAttackCard },

        // STOP
        { front: "stop1", back: "white-back", type: CardTypes.STOP_CARD, class: StopCard },
        { front: "stop2", back: "red-back", type: CardTypes.STOP_CARD, class: StopCard },
        { front: "stop3", back: "orange-back", type: CardTypes.STOP_CARD, class: StopCard },

        // SWITCH-FRIEND
        { front: "switch-friend1", back: "red-back", type: CardTypes.SWITCH_FRIEND_CARD, class: SwitchFriendCard },
        { front: "switch-friend3", back: "green-back", type: CardTypes.SWITCH_FRIEND_CARD, class: SwitchFriendCard },

        // SWITCH-STACK
        { front: "switch-stack1", back: "red-back", type: CardTypes.SWITCH_STACK_CARD, class: SwitchStackCard },
        { front: "switch-stack2", back: "yellow-back", type: CardTypes.SWITCH_STACK_CARD, class: SwitchStackCard },
        { front: "switch-stack3", back: "orange-back", type: CardTypes.SWITCH_STACK_CARD, class: SwitchStackCard },

        // SURPRISE-MEAL
        { front: "surprise-meal2", back: "white-back", type: CardTypes.SURPRISE_MEAL_CARD, class: SurpriseMealCard },
        { front: "surprise-meal3", back: "orange-back", type: CardTypes.SURPRISE_MEAL_CARD, class: SurpriseMealCard },

        // JOKER
        { front: "joker1", back: "blue-back", type: CardTypes.JOKER_CARD, class: JokerCard },
        { front: "joker3", back: "yellow-back", type: CardTypes.JOKER_CARD, class: JokerCard },

        // CANDY
        { front: "candy", back: "pink-back", type: CardTypes.CANDY_CARD, class: CandyCard }
    ];

    static CANDY_PILE_MAP = [
        // CANDY
        { front: "candy", back: "pink-back", type: CardTypes.CANDY_CARD, class: CandyCard },

        // SWITCH-FRIEND
        { front: "switch-friend2", back: "pink-back", type: CardTypes.SWITCH_FRIEND_CARD, class: SwitchFriendCard },

        // SURPRISE-MEAL
        { front: "surprise-meal1", back: "pink-back", type: CardTypes.SURPRISE_MEAL_CARD, class: SurpriseMealCard },

        // JOKER
        { front: "joker2", back: "pink-back", type: CardTypes.JOKER_CARD, class: JokerCard }
    ];
}
